export const createHeadlineDataId = ({ giveawayId }) => {
    return `twitch-gift-breakdown-${giveawayId}`;
};
